import SearchLandingPage from '@/components/modules/Landing/SearchLandingPage';
import { searchLandingPages } from '@/content/searchLandingPages';

const SaasSolutionPage = () => <SearchLandingPage config={searchLandingPages.saas} />;

export default SaasSolutionPage;
